import styled from "styled-components";
import TableViewConfig from "./TableViewConfig";

interface IStyledTableProps {
	config: TableViewConfig;
}

const StyledTable = styled.table<IStyledTableProps>`
	width: 100%;
	border-collapse: collapse;
	border-spacing: 0;

	td {
		border-right: 2px solid #ececec;
		border-top: 2px solid #ececec;
		padding: 15px;
		background: #fff;
		vertical-align: top;

		&:last-child {
			border-right: 0;
		}

		&.primary {
			width: 70%;
		}
	}

	th {
		border-right: 0;
		padding: 10px 15px;
		font-size: 16px;
		font-weight: bold;
		background: transparent;
	}

	tr:first-child td {
		border-bottom: 0;
	}
`;

export default StyledTable;



// WEBPACK FOOTER //
// ./src/common/views/table/StyledTable.tsx